import { render, staticRenderFns } from "./DetailOtherInfo.vue?vue&type=template&id=7ee51eb8&"
import script from "./DetailOtherInfo.vue?vue&type=script&lang=js&"
export * from "./DetailOtherInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports